import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "export-task-item d-flex align-items-center justify-content-between gap-3 py-2" }
const _hoisted_2 = { class: "flex-grow-1 overflow-hidden" }
const _hoisted_3 = { class: "d-flex align-items-center gap-2 mb-1" }
const _hoisted_4 = { class: "text-truncate" }
const _hoisted_5 = {
  key: 0,
  class: "mb-1"
}
const _hoisted_6 = { class: "text-muted" }
const _hoisted_7 = {
  key: 1,
  class: "small text-danger text-truncate"
}
const _hoisted_8 = { class: "text-muted d-block" }
const _hoisted_9 = { class: "d-flex gap-2 flex-shrink-0" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_progress_bar = _resolveComponent("b-progress-bar")!
  const _component_b_progress = _resolveComponent("b-progress")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.sysnameLabel), 1),
        _createElementVNode("span", {
          class: _normalizeClass(["badge", _ctx.statusBadgeClass])
        }, _toDisplayString(_ctx.statusLabel), 3)
      ]),
      (_ctx.task.status === _ctx.ExportTaskStatus.IN_PROGRESS)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_b_progress, {
              max: _ctx.task.progress.of,
              style: {"height":"6px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_b_progress_bar, {
                  value: _ctx.task.progress.sheet,
                  class: "bg-success"
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 8, ["max"]),
            _createElementVNode("small", _hoisted_6, _toDisplayString(_ctx.progressLabel), 1)
          ]))
        : (_ctx.task.status === _ctx.ExportTaskStatus.FAILED)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.helper.trans('export_tasks.generation_error')), 1))
          : _createCommentVNode("", true),
      _createElementVNode("small", _hoisted_8, _toDisplayString(_ctx.dateHelper.format(_ctx.task.createdAt)), 1)
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_ctx.task.downloadable)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-sm btn-outline-success text-nowrap",
            disabled: _ctx.downloading,
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDownload && _ctx.onDownload(...args)), ["prevent"]))
          }, [
            _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fa fa-download" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.download')), 1)
          ], 8, _hoisted_10))
        : _createCommentVNode("", true),
      (_ctx.task.status === _ctx.ExportTaskStatus.IN_PROGRESS)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            type: "button",
            class: "btn btn-sm btn-outline-danger text-nowrap",
            disabled: _ctx.cancelling,
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)), ["prevent"]))
          }, _toDisplayString(_ctx.helper.trans('button.cancel')), 9, _hoisted_11))
        : _createCommentVNode("", true)
    ])
  ]))
}